import { System_Roles_Enum } from '@main/graphql/types.generated';

export const STATUSES = {
  active: {
    value: 'Active',
    tone: 'success' as const,
  },
  disabled: {
    value: 'Disabled',
    tone: 'neutral' as const,
  },
};

export const ROLES_MAP = {
  [System_Roles_Enum.Admin]: { label: 'Admin', colorScheme: 'orange' },
  [System_Roles_Enum.Member]: { label: 'Member', colorScheme: 'purple' },
  [System_Roles_Enum.Auditor]: { label: 'Auditor', colorScheme: 'gray' },
};

export function getRoleTagConfig(role: {
  id: string;
  name: string;
  system_role?: System_Roles_Enum | null;
}) {
  return {
    value: role.id,
    ...(role.system_role ? ROLES_MAP[role.system_role] : { label: role.name, colorScheme: 'gray' }),
  };
}
